import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enCommon from "./locales/en/common.json";
import enHome from "./locales/en/home.json";
import enPages from "./locales/en/pages.json";
import enBooking from "./locales/en/booking.json";
import enServices from "./locales/en/services.json";
import enQuiz from "./locales/en/quiz.json";

import elCommon from "./locales/el/common.json";
import elHome from "./locales/el/home.json";
import elPages from "./locales/el/pages.json";
import elBooking from "./locales/el/booking.json";
import elServices from "./locales/el/services.json";
import elQuiz from "./locales/el/quiz.json";

export const SUPPORTED_LANGUAGES = ["en", "el"] as const;
export type AppLanguage = (typeof SUPPORTED_LANGUAGES)[number];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LANGUAGES as unknown as string[],
    ns: ["common", "home", "pages", "booking", "services", "quiz"],
    defaultNS: "common",
    resources: {
      en: { common: enCommon, home: enHome, pages: enPages, booking: enBooking, services: enServices, quiz: enQuiz },
      el: { common: elCommon, home: elHome, pages: elPages, booking: elBooking, services: elServices, quiz: elQuiz },
    },
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      lookupLocalStorage: "stl_lang",
      caches: ["localStorage"],
    },
    interpolation: { escapeValue: false },
    returnNull: false,
  });

// Keep <html lang> in sync
const applyHtmlLang = (lng: string) => {
  if (typeof document !== "undefined") {
    document.documentElement.lang = lng;
  }
};
applyHtmlLang(i18n.language || "en");
i18n.on("languageChanged", applyHtmlLang);

export default i18n;
